import {
  Card,
  CardContent,
  CardHeader,
  Typography,
  ListItem,
  ListItemText,
  Avatar,
  Grid,
  CardActions,
  List,
  ListItemSecondaryAction,
  Divider,
  Box,
  Link,
} from "@material-ui/core";
import { QuestionAnswer, KeyboardArrowRight } from "@material-ui/icons";

import React from "react";

function replaceValue(value) {
  if (value === true) {
    return "yes";
  } else if (value === false) {
    return "no";
  }
  return value;
}
export function Academics(props) {
  const { data } = props;
  const preventDefault = (event) => event.preventDefault();
  const academicsData = {
    fourYearGraduationRate: {
      title: "Four Year Graduation Rate",
      value: replaceValue(
        data.fourYearGraduationRate && typeof data.fourYearGraduationRate
          ? (data.fourYearGraduationRate * 100).toFixed(2) + "%"
          : null
      ),
    },
    gpaRequirement: {
      title: "GPA Requirement",
      value: replaceValue(data.gpaRequirement),
    },
    rankingsBestCollegeAcademics: {
      title: "Rankings Best College Academics",
      value: replaceValue(
        data.rankingsBestCollegeAcademics &&
          data.rankingsBestCollegeAcademics.value
      ),
    },
    rankingsBestCollegeProfessors: {
      title: "Rankings Best College Professors",
      value: replaceValue(
        data.rankingsBestCollegeProfessors &&
          data.rankingsBestCollegeProfessors.value
      ),
    },
  };

  return (
    <Card id="academics" className="pt-5 px-5">
      <CardHeader title="Academics"></CardHeader>
      <CardContent>
        <Grid container alignItems="flex-end">
          <Grid item>
            <Typography variant="h6">Professors</Typography>
            <ListItem button>
              <Avatar className="mr-4">
                <QuestionAnswer />
              </Avatar>
              <ListItemText primary="Based on faculty accomplishments, salary, student reviews, and additional factors." />
            </ListItem>
            <List>
              {[
                "fourYearGraduationRate",
                "gpaRequirement",
                "rankingsBestCollegeAcademics",
                "rankingsBestCollegeProfessors",
              ].map((keyName, index) => (
                <Box key={index}>
                  <ListItem>
                    <ListItemText>
                      <Typography>{academicsData[keyName].title}</Typography>
                    </ListItemText>
                    <ListItemSecondaryAction>
                      <Typography>
                        {academicsData[keyName].value
                          ? academicsData[keyName].value.toString()
                          : "--"}
                      </Typography>
                    </ListItemSecondaryAction>
                  </ListItem>
                  <Divider />
                </Box>
              ))}
            </List>
          </Grid>
        </Grid>
      </CardContent>
      <hr className="mb-0" />
      <CardActions>
        <Typography variant="body1" color="primary" className="ml-auto mr-2">
          <Link
            href={window.location.href + "/academics"}
            onLClick={preventDefault}
          >
            Read More About Academics <KeyboardArrowRight />
          </Link>
        </Typography>
      </CardActions>
    </Card>
  );
}
